import React, { useContext, useEffect } from "react";
import L from "leaflet";
import * as ReactDOMServer from "react-dom/server";
import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet";
import { ReactComponent as DeliveryDestinationSVG } from "../../../../../../../../images/svg/public/order/delivery-destination.svg";
import { ReactComponent as DeliveryEmployeeSVG } from "../../../../../../../../images/svg/public/order/delivery-employee.svg";
import { OrderContext } from "../../../../contexts/OrderContext";

const FitBoundsToMarkers = ({
	points,
	padding = [20, 20],
}: {
	points: [number, number][];
	padding?: [number, number];
}) => {
	const map = useMap();

	useEffect(() => {
		if (points.length > 1) {
			const bounds = L.latLngBounds(points);
			map.fitBounds(bounds, { padding });
		}
	}, [points, map, padding]);

	return null;
};

const OrderDeliveryMap = () => {
	const { order } = useContext(OrderContext);

	if (order?.preparation_status_changes?.delivered_at) return <></>;

	const deliveryEmployeeCoordinates = order?.delivery?.delivery_employee?.coordinates ?? order?.company?.coordinates;

	if (!deliveryEmployeeCoordinates || !order?.delivery?.coordinates) return <></>;

	const deliveryCoordinates = order.delivery.coordinates;

	const deliveryEmployeeIcon = L.divIcon({
		className: "",
		html: ReactDOMServer.renderToString(<DeliveryEmployeeSVG className="icon" />),
	});
	const deliveryDestinationIcon = L.divIcon({
		className: "",
		html: ReactDOMServer.renderToString(<DeliveryDestinationSVG className="icon" />),
	});

	return (
		<MapContainer
			zoomControl={false}
			scrollWheelZoom={false}
			center={[deliveryEmployeeCoordinates.latitude, deliveryEmployeeCoordinates?.longitude]}
			dragging={false}
			doubleClickZoom={false}
			touchZoom={false}
			keyboard={false}
			tap={false}
			boxZoom={false}
			attributionControl={false}
		>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>
			<Marker
				icon={deliveryEmployeeIcon}
				position={[deliveryEmployeeCoordinates.latitude, deliveryEmployeeCoordinates.longitude]}
			/>
			<Marker
				icon={deliveryDestinationIcon}
				position={[deliveryCoordinates.latitude, deliveryCoordinates.longitude]}
			/>
			<FitBoundsToMarkers
				points={[
					[deliveryEmployeeCoordinates.latitude, deliveryEmployeeCoordinates.longitude],
					[deliveryCoordinates.latitude, deliveryCoordinates.longitude],
				]}
			/>
		</MapContainer>
	);
};

export default OrderDeliveryMap;
